import { useQuery } from '@tanstack/react-query';
import { getCallbackQueue } from '@/services/dashboard-service/dashboard.service';
import { DashboardFilters } from '@/services/dashboard-service/dashboard.service.types';
import { ReactQueryKeys } from '@/utils/react-query-keys';

/** `active` lets a caller that is not rendering the queue skip the request outright. */
export const useCallbackQueue = (
  params: DashboardFilters,
  isCompanyAdmin?: boolean,
  active = true
) => {
  const enabled = active && (isCompanyAdmin || !!params.company_name);

  const {
    data: callbackQueueData,
    error,
    isLoading,
  } = useQuery({
    queryKey: ReactQueryKeys.CALLBACK_QUEUE(params),
    queryFn: () => getCallbackQueue(params),
    enabled,
  });

  return { callbackQueueData, error, isLoading };
};
